const API_BASE_URL = (
  process.env.VUE_APP_API_BASE_URL ||
  process.env.VUE_APP_RECHARGE_API_BASE_URL ||
  'https://raya.smnm.xyz/api/v1'
).replace(/\/$/, '')

/** Package the official website distributes. Store builds live under a different app id. */
const OFFICIAL_APP_ID = 'official'

/**
 * Permanent Android download address. It always resolves to the newest published build, so the
 * link stays correct without the site being rebuilt for every release.
 */
export function apkDownloadUrl(appId = OFFICIAL_APP_ID) {
  return `${API_BASE_URL}/party/version/apk/download?appId=${encodeURIComponent(appId)}`
}

/**
 * Reads the newest published Android build. Resolves to null when nothing is published yet or the
 * backend is unreachable, so the page can keep showing its "coming soon" state instead of an error.
 */
export async function getLatestApk(appId = OFFICIAL_APP_ID) {
  try {
    const response = await fetch(
      `${API_BASE_URL}/party/version/apk/latest?appId=${encodeURIComponent(appId)}`,
      { headers: { Accept: 'application/json' } }
    )
    if (!response.ok) return null

    const payload = await response.json()
    if (payload && payload.code != null && Number(payload.code) !== 200) return null

    const release = payload && payload.data
    return release && release.versionName ? release : null
  } catch (error) {
    return null
  }
}
